module.exports = __webpack_public_path__ + "static/img/column_img_12-2.f346a0fd.png";